<div class="ps-2 name-tag d-flex align-items-center" [class.name-tag-alert]="redBorder">
  {{ fileName }}
  <ng-content select="[statusIcon]"> </ng-content>
  <button
    ds-button
    class="ms-2"
    type="button"
    [variant]="DsButtonVariants.secondary"
    [borderColors]="DsButtonBorderColors.none"
    [isIconOnly]="true"
    [icon]="Icons.XMark"
    [iconStyle]="IconStyles.Light"
    [attr.aria-label]="'upload_action_remove_named_file' | translate: fileName"
    (click)="buttonClicked()"
  ></button>
</div>
